import * as React from "react"
export const Svg_062 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M39.564 25.316a2.35 2.35 0 0 0-2.348 2.349 2.35 2.35 0 0 0 2.348 2.348 2.35 2.35 0 0 0 2.348-2.349 2.35 2.35 0 0 0-2.348-2.348Z"
      />
      <path
        fill="url(#c)"
        d="M53.812 10.38v41.185a5.494 5.494 0 0 0 5.186-5.48V15.86c0-2.924-2.3-5.322-5.186-5.479Z"
      />
      <path
        fill="url(#d)"
        d="M.002 15.86v30.226c0 2.924 2.3 5.322 5.186 5.479V10.38a5.494 5.494 0 0 0-5.186 5.48Z"
      />
      <path
        fill="url(#e)"
        d="M41.83 10.372V0H17.17v10.372H8.645v41.201h1.383v3.111h3.457v-3.11h1.052a15.669 15.669 0 0 1-.764-4.845c0-8.672 7.056-15.727 15.728-15.727 8.673 0 15.728 7.055 15.728 15.727 0 1.69-.268 3.318-.763 4.844h1.05v3.111h3.456v-3.11h1.383V10.371H41.83ZM15.975 27.698l-1.759-2.976 8.864-5.237 1.759 2.977-8.864 5.236Zm4.652-17.326V3.457h17.746v6.915H20.627ZM39.564 33.47a5.812 5.812 0 0 1-5.805-5.805c0-3.201 2.604-5.806 5.805-5.806a5.812 5.812 0 0 1 5.805 5.805 5.812 5.812 0 0 1-5.805 5.806Z"
      />
      <path
        fill="url(#f)"
        d="M41.772 46.73c0-6.767-5.505-12.271-12.27-12.271-6.767 0-12.271 5.504-12.271 12.27S22.735 59 29.5 59s12.271-5.505 12.271-12.27Zm-13.664 6.08L22.4 47.102l2.445-2.444 3.263 3.263 6.05-6.05 2.444 2.444-8.494 8.495Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={38.302}
        x2={40.533}
        y1={26.021}
        y2={29.631}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={55.011}
        x2={63.571}
        y1={16.558}
        y2={18.302}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={1.201}
        x2={9.761}
        y1={16.558}
        y2={18.302}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={18.29}
        x2={46.702}
        y1={8.203}
        y2={43.275}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={22.906}
        x2={34.563}
        y1={38.14}
        y2={57.006}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)